<template>
	<footer class="app-footer">
		<recent-decks />

		<div class="legal wrap">
			<p>
				<strong class="group">
					<a href="/">MTG Deck Builder</a> by
					<a href="https://iristormdesign.com" target="_blank"
						>Iristorm Design<svg>
							<use href="#open-in-new-icon" />
						</svg>
					</a>
				</strong>
				<span class="group">
					<span class="divider"> // </span>
					<a
						href="https://mtgcarpenter.com/terms?src=mdb-redirect"
						target="_blank"
						>Terms of Service</a
					>
					<span class="divider"> // </span>
					<a
						href="https://mtgcarpenter.com/privacy?src=mdb-redirect"
						target="_blank"
						>Privacy Policy</a
					>
					<span class="divider"> // </span>
					<a
						href="https://mtgcarpenter.com/contact?src=mdb-redirect"
						target="_blank"
						>Contact App Manager</a
					>
				</span>
			</p>
			<p v-if="$route?.name === 'home'">
				Intro background illustration from
				<a
					href="https://magic.wizards.com/en/news#wallpapers"
					@click="
						gtagEvent('illustration_source_link_click', {
							CARD_NAME: 'Invasion of Dominaria',
						})
					"
					target="_blank"
					>Invasion of Dominaria<svg>
						<use href="#open-in-new-icon" />
					</svg>
				</a>
				by Denys Tsiperko.
			</p>
			<p>
				<a href="https://magic.wizards.com" target="_blank"
					><i>Magic: The Gathering</i
					><svg>
						<use href="#open-in-new-icon" />
					</svg>
				</a>
				brand and content are TM and &copy; by Wizards of the Coast, LLC. All
				other content, unless indicated otherwise, is copyright &copy;
				{{ new Date().getFullYear() }} by Damian Schmidt of Iristorm Design. MTG
				Deck Builder is not affiliated with or explicitly endorsed by Wizards of
				the Coast, but is permitted under its Fan Content Policy.
			</p>
		</div>
	</footer>
</template>

<script setup>
import { event as gtagEvent } from 'vue-gtag'
import RecentDecks from '@/components/RecentDecks.vue'
</script>

<style lang="scss">
@use '@/sass/app-footer.scss';
</style>
